import { refs, domReady } from '../modules/utils.js';

class CountdownBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-days', 'data-hours', 'data-minutes', 'data-seconds'];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    if (this.replaced) return;

    await domReady();
    this.refs = refs(this);
    this.#listeners();

    if (this.dataset.date) {
      this.date = new Date(this.dataset.date);
      this.#timer();
    }
    // replace parent element with this component
    if (!this.replaced) {
      this.replaced = true;
      const parent = this.parentElement;
      parent.replaceWith(this);
    }
  }

  #listeners() { }

  #timer() {
    if (!this.date?.constructor === Date) return;
    this.now = new Date();
    const days = Math.floor((this.date - this.now) / (1000 * 60 * 60 * 24));
    const daysString = days < 10 ? `0${days}` : days;
    const hours = Math.floor((this.date - this.now) / (1000 * 60 * 60)) % 24;
    const hoursString = hours < 10 ? `0${hours}` : hours;
    const minutes = Math.floor((this.date - this.now) / (1000 * 60)) % 60;
    const minutesString = minutes < 10 ? `0${minutes}` : minutes;
    const seconds = Math.floor((this.date - this.now) / 1000) % 60;
    const secondsString = seconds < 10 ? `0${seconds}` : seconds;

    this.refs.days.textContent = days < 0 ? 0 : daysString;
    this.refs.hours.textContent = hours < 0 ? 0 : hoursString;
    this.refs.minutes.textContent = minutes < 0 ? 0 : minutesString;
    this.refs.seconds.textContent = seconds < 0 ? 0 : secondsString;
    setTimeout(() => this.#timer(), 1000);
  }
}

customElements.define('countdown-bar', CountdownBar);
